import React, { useContext, useEffect, useState } from "react";
import { Table, Tag, Space, Button } from "antd";
import _ from "lodash";
import { LanguageContext } from "../../../context/LanguageContext";
import moment from "moment";
import { useLocation } from "react-router-dom";

const data = [];

export const GhunhaInfomationTable = (props) => {
  const [tblData, SetTblData] = useState([]);
  const { t } = useContext(LanguageContext);
  const location = useLocation();
  const showArrestNotice = location.pathname.indexOf("/add-crime") === -1;
  const requiredKyes = [
    "stateName",
    "cityName",
    "districtName",
    "headingName",
    "registernumber",
  ];
  function parseDateAnyFormat(dateStr) {
    dateStr = dateStr?.trim();
    let dateObj = new Date(dateStr);
    if (!isNaN(dateObj)) return dateObj;
    dateStr = dateStr?.replace(/[-.]/g, "/");
    const parts = dateStr?.split(/[/\s,:]+/);
    if (parts?.length === 3) {
      if (parts[0]?.length === 4) {
        if (parseInt(parts[1]) > 12) {
          dateObj = new Date(`${parts[0]}/${parts[2]}/${parts[1]}`);
        } else {
          dateObj = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
        }
      } else if (parts[2]?.length === 4) {
        dateObj = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
    } else if (parts?.length === 6) {
      if (parts[0]?.length === 4) {
        dateObj = new Date(
          `${parts[0]}/${parts[1]}/${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      } else {
        dateObj = new Date(
          `${parts[2]}/${parts[1]}/${parts[0]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      }
    }
    return !isNaN(dateObj) ? dateObj : "Invalid Date";
  }
  const columns = [
    {
      title: "गुन्हाचे राज्य",
      dataIndex: "stateName",
      key: "stateName",
      render: (text) => <a>{text}</a>,
    },
    {
      title: t("unit"),
      dataIndex: "cityName",
      key: "cityName",
    },
    {
      title: t("crime_police_station"),
      dataIndex: "districtName",
      key: "districtName",
    },
    // {
    //   title: t("crime_registration_date"),
    //   dataIndex: "dateTime",
    //   key: "dateTime",
    //   render: (text, record) => (
    //     <>
    //       {(() => {
    //         const parsed = parseDateAnyFormat(record?.dateTime);
    //         if (parsed === "Invalid Date") return "-";
    //         return parsed.toLocaleDateString("en-GB");
    //       })()}
    //     </>
    //   ),
    // },
    {
      title: t("crime_registration_date"),
      dataIndex: "dateTime1",
      key: "dateTime1",
    },
    {
      title: t("crime_register_number"),
      dataIndex: "registernumber",
      key: "registernumber",
    },
    {
      title: t("title"),
      dataIndex: "headingName",
      key: "headingName",
    },

    // {
    //   title: t("action"),
    //   key: "action",
    //   render: (text, record) => (
    //     <Space size="middle">
    //       <a onClick={() => gunhaFormEdit(record)}>{t("update")}</a>
    //       {/*<a onClick={() => gunhaFormDelete(record)}>Delete</a>*/}
    //       <a onClick={() => gunhaFormArrest(record)}>{t("arrest")}</a>
    //       <a onClick={() => gunhaFormNotice(record)}>{t("notice")}</a>
    //     </Space>
    //   ),
    // },

    {
      title: t("action"),
      key: "action",
      render: (text, record) => (
        <Space size={8}>
          {/* <Button
            type="primary"
            size="middle"
            onClick={() => gunhaFormEdit(record)}
          >
            {t("update")}
          </Button> */}

          <Button
            type="primary"
            size="middle"
            onClick={() => gunhaFormArrest(record)}
          >
            {t("arrest")}
          </Button>

          <Button
            type="primary"
            size="middle"
            onClick={() => gunhaFormNotice(record)}
          >
            {t("notice")}
          </Button>
        </Space>
      ),
    },
  ];

  // useEffect(() => {
  //   const { gunhaInfor } = props.professionals;
  //   if (gunhaInfor && gunhaInfor.length) {

  //   }
  // }, [props.isAccusedFormEdit && props.isAccusedFormEdit.idEdit]);

  const getStateName = (id) => {
    const { pc_countrystates } = props.professionals;
    if (pc_countrystates && pc_countrystates.length) {
      return (
        _.filter(pc_countrystates, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_countrystates, function (o) {
          return o.id === id;
        })[0].state
      );
    }
  };

  const getDistrictName = (id) => {
    const { gunhaDistricts } = props.professionals;
    if (gunhaDistricts && gunhaDistricts.length) {
      return (
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  const getCityName = (id) => {
    const { pc_cities } = props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const getCriminalTitles = (id) => {
    const { pc_crimetitles } = props.professionals;
    if (pc_crimetitles && pc_crimetitles.length) {
      return (
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0].crime_title
      );
    }
  };

  // useEffect(() => {
  //   let tempData = [];
  //   tempData =
  //     props.data &&
  //     props.data.map((res, index) => {
  //       return {
  //         ...res,
  //         key: index + 1,
  //         cityName: getCityName(res.city),
  //         headingName: res.headingName
  //           ? res.headingName
  //           : getCriminalTitles(res.heading),
  //         stateName: getStateName(res.state),
  //         // districtName:getDistrictName(res.district)
  //       };
  //     });
  //   SetTblData(tempData);
  //   // SetTblData
  // }, [props.isEditForms]);

  useEffect(() => {
    let tempData = [];

    tempData =
      props.data &&
      props.data.map((res, index) => {
        return {
          ...res,
          key: index + 1,
          dateTime1: moment(res.dateTime).format("DD-MM-YYYY"),
          cityName: getCityName(res && res.city),
          headingName:
            res && res.headingName
              ? res.headingName
              : getCriminalTitles(res && res.heading),
          stateName: getStateName(res && res.state),
        };
      });
    SetTblData(tempData);
    // SetTblData
  }, [props.data]);

  const gunhaFormEdit = (data) => {
    props.editGhunhaInfomation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      }),
    );
  };
  const gunhaFormDelete = (data) => {
    props.deleteGhunhaInfomation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      }),
    );
  };

  const gunhaFormNotice = (data) => {
    props.editNoticeInformation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      }),
    );
  };
  const gunhaFormArrest = (data) => {
    props.editArrestInfomation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      }),
    );
  };

  return <Table columns={columns} dataSource={tblData} />;
};
